import React from 'react';
import styles from './errorPageContent.scss';
import { FormattedMessage } from 'react-intl';

import serverVars from 'server-vars';
const cdnDomain = serverVars.get('config.cdnDomain');
const errorImgSrc = '/mobile/public/dist/ea0cd2bc2590150dbc1665eb44d3dd95.jpg';

function ErrorPageContent() {
    const messageLink = (
        <a href="" title="Reload current page">
            <FormattedMessage
                id="ErrorPageContent.messageLink"
                defaultMessage="try loading this page again"
            />
        </a>
    );

    return (
        <div className={styles.content}>
            <h3 className={styles.title}>
                <FormattedMessage
                    id="ErrorPageContent.title"
                    defaultMessage="Sorry, we're currently experiencing technical difficulties."
                />
            </h3>
            <p>
                <FormattedMessage
                    id="ErrorPageContent.message"
                    defaultMessage="We know your time is valuable. Give us a few seconds and {messageLink}."
                    values={{ messageLink }}
                />
            </p>
            <img
                className={styles.image}
                src={`${cdnDomain}${errorImgSrc}`}
                alt="Please refresh page"
            />
        </div>
    );
}

export default ErrorPageContent;
